export * from './class';
export * from './opacity';
export * from './stroke';
//# sourceMappingURL=main.js.map